import NewReleasesIcon from "@mui/icons-material/NewReleases";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIcon } from "../ListStateIcon";

interface IListStateIconUnreadProps {
    unread: boolean
    noMargin?: boolean;
}

export const ListStateIconUnread = (props: IListStateIconUnreadProps) => {
    if (!props.unread) return null;
    return (
        <ListStateIcon
            tooltip={Translations.Unread}
            icon={NewReleasesIcon}
            color="warning"
            noMargin={props.noMargin}
        />
    );
};
